/** Booking Sync — the standalone page: scope picker + the embeddable
 *  BookingSyncForm (which owns the capability-gated criteria, the booking-ID
 *  mode, the advanced options and the launch). The setup wizard hosts the same
 *  form with a fixed scope and an injected launch path.
 */
import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import { HelpLink } from '@/components/HelpLink';

import { BookingSyncForm } from './BookingSyncForm';
import { SyncScopePicker, initialSyncScope, type SyncScope } from './SyncScopePicker';

export function BookingSyncPage() {
  const [scope, setScope] = useState<SyncScope>(initialSyncScope);

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Booking Sync <HelpLink story="booking-sync" />
      </Typography>

      <BookingSyncForm
        scope={scope}
        scopeSlot={
          <SyncScopePicker
            value={scope}
            onChange={setScope}
            requiredFeature="booking_sync"
          />
        }
      />
    </Box>
  );
}
